import angular from 'angular';

let floorValues = [
	'-4',
	'-3',
	'-2',
	'-1',
	'alagsor',
	'szuteren',
	'felszuteren',
	'foldszint',
	'magasfoldszint',
	'felemelet'
];

let anyitNiceUrl = {
	keys: {
		'ertekesitestipusa': 'ertekesitestipusa',
		'ingatlantipusa': 'ingatlantipusa',
		'arMinimum': 'ar',
		'arMaximum': 'ar',
		'meretMinimum': 'meret',
		'meretMaximum': 'meret',
		'selectedTags': 'elhelyezkedes',
		'locationTypes': 'elhelyezkedestipusa',
		'order': 'rendezes',
		'buildingStructure': 'epitesimod',
		'conditionOfProperty': 'allapot',
		'heating': 'futes',
		'roomsMin': 'szobak',
		'roomsMax': 'szobak',
		'bathroomsMax': 'furdoszobak',
		'bathroomsMin': 'furdoszobak',
		'floorMin': 'emelet',
		'floorMax': 'emelet',
		'elevator': 'lift',
		'comfortLevel': 'komfort',
		'miscellaneous': 'egyeb',
		'parkingOption': 'parkolas',
		'rooms.type': 'erkely',
		'view': 'kilatas',
		'staircaseType': 'lepcsohaz',
		'livingRoomOrientation': 'tajolas',
		'keyWord': 'kulcsszo',
		'project.id': 'projektazonosito',
		'isOwnedByFactoring': 'faktoring',
		'innerHeightMax': 'belmagassag',
		'innerHeightMin': 'belmagassag',
		'floorsInBuildingMin': 'szint',
		'floorsInBuildingMax': 'szint',
		'page': 'oldal',
		'pageSize': 'darab',
		'location': 'koordinatak',
		'comissionId': 'comissionId'
	}, values: {
		'ertekesitestipusa': ['elado', 'kiado'],
		'ingatlantipusa': [
			'lakas',
			'haz',
			'lakas&haz',
			'telek',
			'garazs',
			'projektingatlan',
			'iroda',
			'uzlethelyiseg',
			'vendeglatas',
			'ipari',
			'mezogazdasagi',
			'fejlesztesi-telek',
			'kozintezmeny-ingatlanja'
		],
		'order': {
			'orderBy=createDateTime&orderDirection=desc': 'datum-szerint-csokkeno',
			'orderBy=createDateTime&orderDirection=asc': 'datum-szerint-novekvo',
			'orderBy=priceHuf&orderDirection=asc': 'ar-szerint-novekvo',
			'orderBy=priceHuf&orderDirection=desc': 'ar-szerint-csokkeno'
		},
		'buildingStructure': {
			wood: 'fa',
			woodHouse: 'fa',
			brick: 'tegla',
			rockAndBrick: 'tegla',
			panel: 'panel',
			shutter: 'panel',
			lightStructure: 'konnyu-szerkezet',
			adobe: 'egyeb',
			silicate: 'egyeb',
			proconcept: 'egyeb',
			mixedMasonry: 'egyeb',
			passiveHouse: 'egyeb',
			otherBuildingMaterial: 'egyeb'
		},
		'heating': {
			gasCirco: 'gaz',
			gasConvector: 'gaz',
			gasHera: 'gaz',
			gasAndAlternative: 'gaz',
			electric: 'elektromos',
			remoteHeating: 'tavfutes',
			remoteHeatingWithOwnMeasurer: 'tavfutes',
			houseCentralized: 'egyeb',
			houseCentralizedWithUniqueMeter: 'egyeb',
			geotermic: 'egyeb',
			furnace: 'egyeb',
			stove: 'egyeb',
			fanCoil: 'egyeb',
			otherHeating: 'egyeb',
			nothing: 'nincs'
		},
		'conditionOfProperty': {
			uninhabitable: 'bontando',
			toRenew: 'felujitando',
			average: 'atlagos',
			good: 'jo',
			excellent: 'felujitott',
			newlyBuilt: 'uj-epitesu'
		},
		'floorMin': angular.copy(floorValues),
		'floorMax': angular.copy(floorValues),
		'elevator': {
			key: 'van',
			caller: 'van',
			service: 'van',
			none: 'nincs'
		},
		'comfortLevel': {
			doubleComfort: 'dupla-komfort',
			luxurious: 'dupla-komfort',
			fullComfort: 'osszkomfort',
			comfort: 'osszkomfort',
			withoutComfort: 'egyeb',
			halfComfort: 'egyeb'
		},
		'miscellaneous': {
			pool: 'medence',
			withGardenAccess: 'kertkapcsolat',
			topFloor: 'tetoteri'
		},
		'parkingOption': {
			roomGarage: 'teremgarazs-garazs',
			closedPlace: 'zart-kocsibeallo',
			openedPlace: 'nyilt-kocsibeallo',
			publicPayment: 'kozteruleten-fizetos',
			publicFree: 'kozteruleten-ingyenes',
			noGarage: 'nincs'
		},
		'rooms.type': {
			balcony: 'erkely',
			terrace: 'terasz-tetoterasz',
			roofTerrace: 'terasz-tetoterasz',
			loggia: 'loggia',
			frenchBalcony: 'francia-erkely'
		},
		'view': {
			street: 'utcai',
			yard: 'udvari',
			garden: 'kertre-nezo',
			panorama: 'panorama'
		},
		'staircaseType': {
			closed: 'zart',
			circularCorridor: 'korholyoso',
			other: 'egyeb'
		},
		'livingRoomOrientation': {
			north: 'eszak',
			northeast: 'eszakkelet',
			northwest: 'eszaknyugat',
			east: 'kelet',
			south: 'del',
			southeast: 'delkelet',
			southwest: 'delnyugat',
			west: 'nyugat'
		},
		'floorsInBuildingMin': ['0'],
		'floorsInBuildingMax': ['0']
	}, keysBack: {
		ertekesitestipusa: 'ertekesitestipusa',
		ingatlantipusa: 'ingatlantipusa',
		ar: ['arMinimum', 'arMaximum'],
		meret: ['meretMinimum', 'meretMaximum'],
		elhelyezkedes: 'selectedTags',
		elhelyezkedestipusa: 'locationTypes',
		rendezes: 'order',
		emelet: ['floorMin', 'floorMax'],
		floorMin: 'floorMin',
		floorMax: 'floorMax',
		szobak: ['roomsMin', 'roomsMax'],
		furdoszobak: ['bathroomsMin', 'bathroomsMax'],
		belmagassag: ['innerHeightMin', 'innerHeightMax'],
		allapot: 'conditionOfProperty',
		futes: 'heating',
		epitesimod: 'buildingStructure',
		lift: 'elevator',
		komfort: 'comfortLevel',
		egyeb: 'miscellaneous',
		parkolas: 'parkingOption',
		erkely: 'rooms.type',
		kilatas: 'view',
		lepcsohaz: 'staircaseType',
		tajolas: 'livingRoomOrientation',
		kulcsszo: 'keyWord',
		projektazonosito: 'project.id',
		faktoring: 'isOwnedByFactoring',
		szint: ['floorsInBuildingMin', 'floorsInBuildingMax'],
		oldal: 'page',
		darab: 'pageSize',
		koordinatak: 'location',
		comissionId: 'comissionId'
	}
};

for (let i = 1; i <= 10; ++i) {
	anyitNiceUrl.values.floorMin.push(i + '');
	anyitNiceUrl.values.floorMax.push(i + '');
	anyitNiceUrl.values.floorsInBuildingMin.push(i + '');
	anyitNiceUrl.values.floorsInBuildingMax.push(i + '');
}
// 20+ érték niceurl-ben ne látszódjon
anyitNiceUrl.values.floorMax.push('');
anyitNiceUrl.values.floorMin.push('');

export default anyitNiceUrl;
